import { render, staticRenderFns } from "./RecyclingSortingAbcPageCustom.vue?vue&type=template&id=ed284ef8&"
import script from "./RecyclingSortingAbcPageCustom.vue?vue&type=script&lang=js&"
export * from "./RecyclingSortingAbcPageCustom.vue?vue&type=script&lang=js&"
import style0 from "./RecyclingSortingAbcPageCustom.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports